module.exports = __webpack_public_path__ + "img/bank.d1831ef3.png";